import React, { useState } from 'react';
/* eslint-disable @typescript-eslint/no-explicit-any */
const Accordion = ({ title, content }: { title: any; content: any }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="d-block pb-1">
      <div
        className="border p-1  rounded"
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
        onClick={() => setIsActive(!isActive)}
      >
        <div className="font-weight-bold">{title}</div>
        <div>{isActive ? '-' : '+'}</div>
      </div>
      {isActive && (
        <div className="p-1" style={{ maxWidth: 800 }}>
          {content}
        </div>
      )}
    </div>
  );
};

export default Accordion;
